<div class="wrapper">
    <mat-icon svgIcon="ico_alert" />
    <p>It looks like this part of our site isn’t working right now. Please try again.</p>
</div>
